import type { RaffleTier } from "entities/wheel-raffle";

// От младшего к старшему: Standard сверху, Platinum снизу.
export const sortTiers = (tiers: RaffleTier[]): RaffleTier[] =>
  [...tiers].sort((a, b) => a.sort_order - b.sort_order);

// Выбранный статус и все выше него — коды для allowed_participant_tiers.
export const getTiersFrom = (
  tiers: RaffleTier[],
  minTierCode: string,
): string[] => {
  const minTier = tiers.find((tier) => tier.tier_code === minTierCode);
  if (!minTier) return [];
  return sortTiers(tiers)
    .filter((tier) => tier.sort_order >= minTier.sort_order)
    .map((tier) => tier.tier_code);
};
